/**
 * Extract email params from param
 * @param {string} email
 * @returns {object} params from email
 */
const extractEmail = (email = '') => {
	const [recipientName, hostnameWithTld = ''] = String(email).split('@');
	const [hostname, tld = ''] = hostnameWithTld.split(/\.([^.]*)$/);
	return {
		recipientName,
		hostname,
		tld
	};
};

/**
 * Build error Object
 * @param {string} origin Error function name
 * @param {string} code Error description (eg code)
 * @param {string} value Validated email
 * @param {string} character Character where error occured
 * @param {string} regexp Regexp used to validate
 * @returns {object}
 */
const buildErrorObject = (origin, code, value, character = '', regexp = new RegExp()) => ({
	origin,
	code,
	value,
	character,
	regexp
});

/**
 * Check if email contains "@" character and also if email does not contain more than one "@" character
 * @param {string} email
 * @throws {Error} if email is invalid
 */
const checkAtSignInEmail = (email) => {
	const atSignsInEmail = email.match(/@/g) || [];
	if (!atSignsInEmail.length) {
		throw buildErrorObject('checkAtSignInEmail', 'missingAtSign', email);
	}
	if (atSignsInEmail.length > 1) {
		throw buildErrorObject('checkAtSignInEmail', 'multipleAtSign', email);
	}
};

/**
 * Check TLD name length
 * @param {string} email
 * @throws {Error} if TLD name is invalid
 */
const checkTldName = (email) => {
	const { tld } = extractEmail(email);
	if (!tld.length) {
		throw buildErrorObject('checkTldName', 'includePartAfterAtSign', email);
	}
	const validTldRegex = /^[a-z]{2,10}$/i;
	if (!validTldRegex.test(tld)) {
		throw buildErrorObject('checkTldName', 'checkPartAfterAtSign', email);
	}
};

/**
 * Check domain name length and allowed characters
 * @param {string} email
 * @throws {Error} if domain name is invalid
 */
const checkDomainName = (email) => {
	const { hostname } = extractEmail(email);
	const invalidDomainNameRegex = /^[-.]|[-.]$|[-.]{2,}|[^a-z0-9-.]/i;
	if (invalidDomainNameRegex.test(hostname) || hostname.length < 1 || hostname.length > 253) {
		throw buildErrorObject('checkDomainName', 'checkPartAfterAtSign', email);
	}
};

/**
 * Check if email before "@" is valid
 * @param {string} email
 * @throws {Error} if email name is invalid
 */
const checkEmailName = (email) => {
	const { recipientName, hostname, tld } = extractEmail(email);
	// Temporary validation for bot names eg. Eleonora789Moretti8765@gmail.com
	const preValidateRegex = /^[A-Z][a-z]+\d{3}[A-Z][a-z]+\d{4}$/;
	if (preValidateRegex.test(recipientName) && hostname === 'gmail' && tld === 'com') {
		throw buildErrorObject('checkEmailName', 'partBeforeAtSign', email);
	}
	if (recipientName.length < 2 || recipientName.length > 64) {
		throw buildErrorObject('checkEmailName', 'partBeforeAtSign', email);
	}
	const validEmailNameRegex = /^[-\w!#$%&\\'*+/=?^`{|}~]+(?:\.[-\w!#$%&\\'*+/=?^`{|}~]+)*$/;
	if (!validEmailNameRegex.test(recipientName)) {
		throw buildErrorObject('checkEmailName', 'partBeforeAtSign', email, '', validEmailNameRegex);
	}
};

export default {
	checkAtSignInEmail,
	checkTldName,
	checkDomainName,
	checkEmailName
};
